(function () {
    const slideshow = () => {
        $(".slideshow-section").each(function () {
            if ($(this).hasClass("slider_started")) { return ""; }
            $(this).addClass("slider_started");
            
            const id = $(this).attr("id");
            
            // Inicijaliziramo Swiper s APSOLUTNIM MINIMUMOM postavki
            // Ovo će "prevariti" temu da pokaže tekst, ali slider će biti statičan
            const swiper = new Swiper(`#${id} .slideshow__swiper`, {
                loop: false,           // Isključeno kruženje
                autoplay: false,       // Isključen autoplay
                allowTouchMove: false, // ISKLJUČEN SWIPE (ovo si htio)
                speed: 0,              // Trenutni prijelaz
                effect: 'fade',        // Najlakši efekt
                navigation: false,     // Isključene strelice
                pagination: false      // Isključene točkice
            });
            
            // Ručno okidamo promjenu boje ako tvoja tema to traži za vidljivost
            $(this).find(".slideshow-slide, .slideshow__text-container").css({
                "opacity": "1",
                "visibility": "visible"
            });
        });
    };

    document.addEventListener("DOMContentLoaded", slideshow);
    document.addEventListener("shopify:section:load", slideshow);
})();